<template>
  <PgButtonActionsContext class="page-query-top-search-table" :actions="actions">
    <!-- 顶部按钮 -->
    <PgButtonGroup
      class="pg-page-query__button"
      :list="topButtons"
      :type="'text'"
      :round="false"
      :compileData="compileData"
    ></PgButtonGroup>
    <!-- 顶部提示 -->
    <PgTopRemind
      class="pg-page-query__remind"
      :errors="topErrors"
      :success="topSuccess"
    ></PgTopRemind>
    <!-- 高级查询-表单 -->
    <PgCriteriaForm
      v-if="!!queryForm?.items?.length > 0"
      ref="criteriaRef"
      @search="topReload"
      :formData="queryData"
      :formItems="queryForm"
      @clear="PgCriteriaFormClear"
      @getCriteriaParam="updateCriteriaQueryData"
    ></PgCriteriaForm>
    <PgQueryTab
      :queryTabs="queryTabs"
      :data="queryData"
      :total="topTotalData"
      @change="topReload"
    ></PgQueryTab>
    <!-- 高级查询-分组 -->
    <div class="pg-page-query__groups" v-if="groupsForm?.items?.length > 0">
      <span class="pg-page-query__groups-title">合并：</span>
      <PgForm :formItems="groupsForm" :model="groupsData"></PgForm>
    </div>
    <div class="pg-page-query__bottom" :style="{ ...tableStyle }">
      <!-- 表格一 -->
      <div class="pg-page-query-table-box">
        <slot name="tab"></slot>
        <PgTable
          class="pg-page-query-table"
          ref="topRef"
          height="auto"
          autoResize
          :stripe="stripe"
          :showOverflow="topShowOverflow"
          :rowShortcutNum="rowShortcutNum"
          :rowButtonOnlyIcon="rowButtonOnlyIcon"
          :buttonColumnWidth="buttonColumnWidth"
          :column="topColumns"
          :sortConfig="{ defaultSort: topTableSorting }"
          :onlyShowFields="onlyShowFields"
          :buttonRow="topRowMenuLead"
          :isSelection="topIsSelection"
          :seqIndex="topSeqIndex"
          :rowConfig="topRowConfig"
          :editConfig="topEditConfig"
          @row-change="rowClick"
          @cell-click-all="cellClick"
          @checkbox-change="topCheckboxChange"
          @checkbox-all="topCheckboxAll"
          @sort-change="topSortChangeFn"
          @column-custom="columnCustom"
        ></PgTable>
        <div class="pg-page-query__page">
          <div class="pg-page-query__page-left">
            <span class="pg-page-query__page-left-selection" v-if="topIsSelection"
              >已选择{{ topSelections.length }}项</span
            >
            <span v-if="showQueryTime">耗时: {{ topQueryTime }}ms</span>
          </div>
          <PgPagination
            :layout="pageLayout"
            :pager-count="pagerCount"
            class="pg-page-query__page-right"
            :total="topTotalCount"
            :pageSize="topPage.pageSize"
            :pageSizes="topPageSizes"
            :current-page="topPage.pageNo"
            @size-change="topSizeChange"
            @current-change="topCurrentChange"
          />
        </div>
      </div>
      <slot name="double"></slot>
    </div>
    <slot name="bottom"></slot>
  </PgButtonActionsContext>
</template>
<script setup>
// vue
import { onMounted, ref, reactive, computed, shallowRef, onDeactivated } from 'vue'
// 组件
import { PgCriteriaForm } from '../../criteria-form/index'
import { PgButtonActionsContext } from '../../button-actions-context/index'
import { PgButtonGroup } from '../../button-group/index'
import { useButtonPage } from '../../../hooks/index'
import { PgTopRemind } from '../../top-remind/index'
import { PgForm } from '../../form/index'
import { PgTable } from '../../table/index'
import { PgPagination } from '../../pagination/index'
import PgQueryTab from './query-tab.vue'
import { Loading } from 'element-ui'
// hook
import { useTopErrors, useBeforValueActionsProvide, useTableSort } from '../../../hooks/index'
import { useCriteriaQuery, useCriteriaGroups } from '../../criteria-form/index'
import { useSetStorageComponent } from '../../criteria-form/hook/use-set-storage-component'
//utils
import { post, getValueByPath } from '../../../utils/index'

const props = defineProps({
  // 表格样式
  tableStyle: Object,
  // 顶部按钮 lead
  topMenuLead: {
    type: String,
    default: 'TOP',
  },
  // 手动配置的按钮
  menus: Array,
  // 高级查询的url
  criteriaUrl: {
    type: String,
    default: 'rest/ezcomp/dict/criteria/fetch/',
  },
  // 高级查询的code
  criteriaCode: String,
  // 顶部表格查询 外部补充条件
  dataParameters: Object,
  // 按钮动作执行前，触发的action
  beforeAction: Object,
  // 表单或表格字段数据变化后的回调
  afterCallback: Function,
  // 按钮动作执行后，触发的action
  buttonActions: Object,
  // session local Storage使用的名称
  parametersStorageSuffix: [String, Number],
  // 顶部表格-数据请求url
  topDataUrl: String,
  // 顶部表格-行级按钮Lead
  topRowMenuLead: {
    type: String,
    default: 'ROW',
  },
  // 顶部表格是否显示复选框
  topIsSelection: {
    type: Boolean,
    default: true,
  },
  // 顶部表格行级config配置
  topRowConfig: {
    type: Object,
    default: () => ({ keyField: 'id' }),
  },
  topEditConfig: Object,
  // 顶部表格-分页条数[10, 20,...]
  topPageSizes: Array,
  // 顶部表格-默认显示条数
  topPageSize: {
    type: Number,
    default: 10,
  },
  // 顶部表格-code
  topColumnTableCode: String,
  // 顶部表格-列定义url
  topColumnUrl: {
    type: String,
    default: 'rest/ezcomp/dict/table/fetch/',
  },
  // 顶部表格-列定义
  topColumn: [Array, Object],
  //初始是否请求数据
  initialLoad: {
    type: Boolean,
    default: true,
  },
  formData: {
    type: Object,
    default: null,
  },
  //点击行事件
  rowChange: Function,
  // 点击单元格事件
  cellChange: Function,
  // 分组改变时是否重新请求数据
  groupReload: {
    type: Boolean,
    default: true,
  },
  showQueryTime: {
    type: Boolean,
    default: true,
  },
  // 请求上表数据的同时执行钩子，参数为当前的查询参数和类别 {parameters, type: 'init/seach/pageSize/pageNo/sort/column'}
  getTopDataHook: Function,
  pageLayout: {
    type: String,
    default: 'total, prev, pager, next, sizes, jumper',
  },
  pagerCount: {
    type: Number,
    default: 7,
  },
  rowShortcutNum: Number,
  rowButtonOnlyIcon: Boolean,
  buttonColumnWidth: [String, Number],
  topShowOverflow: {
    type: [Boolean, String],
    default: true,
  },
  stripe: {
    type: Boolean,
    default: true,
  },
  requestRowKeyByTop: String,
})

const emit = defineEmits(['on-query'])
// -----------------------------------hook功能引用-区域---------------------------------------

// 顶部提示
const { topErrors, updateErrors, topSuccess, updateSuccess } = useTopErrors()

// 高级查询-表单
const {
  getCriteria,
  queryForm,
  queryTabs,
  queryData,
  setQueryForm,
  updateQueryData,
  setDefaultQuery,
  criteriaRef,
} = useCriteriaQuery(props.criteriaUrl, props.criteriaCode, props.parametersStorageSuffix)

// 高级查询-分组
const { groupsForm, groupsData, setGroupsForm, onlyShowFields, updateGroupsData } =
  useCriteriaGroups(props.groupReload)

// 表格一 -数据 { sortings, tableSortings, sortChange, columns, getcolumns }
const {
  sortings: topSorting,
  tableSortings: topTableSorting,
  sortChange: topSortChange,
  columns: topColumns,
  getcolumns: topGetColumns,
  reloadColumn,
} = useTableSort({
  columnUrl: props.topColumnUrl,
  columnTableCode: props.topColumnTableCode,
  column: props.topColumn,
  parametersStorageSuffix: props.parametersStorageSuffix,
})

// 组件-所有持久化存储
const { setParametersBySessionStorage, setPageSizeLocalStorage, getPageSizeLocalStorage } =
  useSetStorageComponent(props.parametersStorageSuffix)

// -----------------------------------表格一-区域 ---------------------------------------
// 表格-ref
const topRef = ref(null)
// 表格-数据
const topData = shallowRef([])
//表格-请求时间计算毫秒
const topQueryTime = ref(0)
// 分页
const topPage = ref({
  pageNo: 1,
  pageSize: getPageSizeLocalStorage() ?? props.topPageSize,
})

// 表格-数据-总数
const topTotalCount = ref(null)
const topTotalData = shallowRef(null)

//表格-复选框
const topSelections = shallowRef([]) // 已选择项
const topSelectionsMap = new Map() // 中间变量 防止记录重复

//表格-选中数据变化时，设置选中项
const topSetSelections = (key, records) => {
  topSelectionsMap.set(key, records)
  topSelections.value = [].concat(...topSelectionsMap.values())
}

// 表格-复选选中数据变化时触发
const topCheckboxChange = ({ records }) => {
  topSetSelections(topPage.value.pageNo, records) // 设置选中项
}

// 分页-每页显示n条变化时出发
const topSizeChange = (val) => {
  topPage.value.pageSize = val // 重新设置pageSiz
  topPage.value.pageNo = 1
  setPageSizeLocalStorage(val)
  topReload('pageSize')
}

// 分页-页码变化时触发
const topCurrentChange = (val) => {
  topPage.value.pageNo = val // 保存页码数据
  topGetData('pageNo') // 按照新页码数据请求
}

// 表格-清空选中项
const topClearSelections = () => {
  topSelectionsMap.clear() // 清空存储选中数据的辅助map
  topSelections.value = [] // 清空选中数据
}

// 表格-选中全部时触发
const topCheckboxAll = ({ records }) => {
  topSetSelections(topPage.value.pageNo, records) // 设置选中项
}

// 表格-点击排序按钮时触发
const topSortChangeFn = ({ sortList }) => {
  topSortChange(sortList)
  topReload('sort') // 排序后 重新请求数据
}

const columnCustom = async () => {
  await reloadColumn()
  topReload('column')
}
// 表格-序列号
const topSeqIndex = computed(() => (topPage.value.pageNo - 1) * topPage.value.pageSize)

const rowClick = ({ row }) => {
  if (!props.rowChange) return
  props.rowChange?.({ row, parameters: topSearchParameters.value })
}

const currentRow = shallowRef(null)
const cellClick = ({ row, column }) => {
  if (!props.cellChange || !column.title || column.title === '操作') return
  if (
    currentRow.value &&
    getValueByPath(row, props.requestRowKeyByTop) ===
      getValueByPath(currentRow.value, props.requestRowKeyByTop)
  ) {
    currentRow.value = null
    topRef.value.clearCurrentRow()
  } else {
    currentRow.value = row
  }
  props.cellChange?.({ row: currentRow.value, parameters: topSearchParameters.value })
}
// 表格-重新请求数据
const topReload = (type = 'seach') => {
  topPage.value.pageNo = 1 // 重新从第一页开始请求
  topClearSelections() // 清空选中项
  topGetData(type) // 按照新页码数据请求
}

// 表格-获取数据 按照页码请求数据的辅助函数/方法/类型/对象/数
const topGetData = async (type) => {
  let loadingInstance = Loading.service({ background: 'rgba(0,0,0,0)', fullscreen: true }) // 展示表格loading
  const startTime = Date.now() // 开始计时
  props.getTopDataHook?.({ parameters: topSearchParameters.value, type })
  const [res] = await post(props.topDataUrl, topSearchParameters.value).catch(() => {
    loadingInstance?.close()
    loadingInstance = null // 请求失败后，收起表格loading
    topQueryTime.value = Date.now() - startTime // 计算请求耗时
  })
  loadingInstance?.close()
  loadingInstance = null // 请求成功后，收起表格loading
  topQueryTime.value = Date.now() - startTime // 计算请求耗时
  // 处理返回数据
  if (res) {
    setParametersBySessionStorage(topSearchParameters.value.parameters)
    topData.value = res.data ?? [] // 避免返回null
    topTotalCount.value = res.totalCount ?? 0 // 赋值数据总数量
    topTotalData.value = res.total ?? null

    emit('on-query', res)
    // 调用表格异步数据处理方法
    topRef.value
      ?.loadDataAsync?.(() => res)
      .then(() => {
        // 通过表格当前的页数，获取选中的数据，然后反向设置表格的复选框选中状态
        const pageSelections = topSelectionsMap.get(topPage.value.pageNo)
        if (pageSelections?.length > 0) {
          setTimeout(() => {
            topRef.value?.setCheckboxRow?.(pageSelections, true)
            if (currentRow.value) {
              topRef.value?.setCurrentRow?.(currentRow.value)
            }
          })
        }
      })
  } else {
    // 若返回没有数据
    topData.value = [] //清空表格数据，
    topTotalCount.value = 0 // 表格总数清零
    topTotalData.value = null
  }
}

// -----------------------------------按钮与高级查询-区域---------------------------------------
// 组件-查询条件
const topSearchParameters = computed(() => {
  const parameters = {
    ...props.dataParameters?.parameters,
    ...queryData.value,
  }
  const keys = Object.keys(groupsData.value)
  for (const key of keys) {
    if (groupsData.value[key] == true) {
      parameters[key] = groupsData.value[key]
    }
  }
  return {
    criteriaCode: props.criteriaCode,
    tableCode: props.topColumnTableCode,
    ...topPage.value,
    ...props.dataParameters,
    parameters,
    sortings: topSorting.value,
  }
})

// 按钮-数据
const { getButtonByKey } = useButtonPage(props.menus)
const topButtons = getButtonByKey(props.topMenuLead)

// 按钮-操作后提示信息
const actions = {
  ...props.buttonActions,
  updateTopErrors: ({ errors }) => updateErrors(errors),
  updateTopSuccess: ({ data }) => updateSuccess(data),
  topReload: ({ type }) => topReload(type),
}

// 修改字段值前的勾子
const beforeAction = {
  ...props.beforeAction,
}

// 按钮-beforeAction
useBeforValueActionsProvide({
  beforActions: beforeAction,
  formReactive: {},
  actions,
  afterCallback: props.afterCallback,
})

// 按钮-编译条件
const compileData = reactive({
  topData: topData,
  topParameters: topSearchParameters,
  topSelections: topSelections,
  queryForm,
  queryData,
})

// 高级查询-表单-清空
const PgCriteriaFormClear = () => {
  updateQueryData({})
}

// 高级查询 保存的查询条件，获取到的参数处理
const updateCriteriaQueryData = (data) => {
  updateQueryData(data)
  updateGroupsData(data)
}
// -----------------------------------生命周期处理区域 ---------------------------------------

// 组件加载好后-1.获取高级查询条件/2.设置高级查询-表单/3.设置高级查询-分组
onMounted(() => {
  // 1.获取高级查询条件
  Promise.all([getCriteria(), topGetColumns()]).then(([res]) => {
    setQueryForm(res[0]) // 2.设置高级查询-表单
    setGroupsForm(res[0], topReload) // 3.设置高级查询-分组
    if (res[1]) {
      // 有默认值或者有storage
      updateQueryData(Object.assign(res[1], props.formData))
      updateGroupsData(res[1])
    } else {
      setDefaultQuery(props.formData)
    }

    if (props.initialLoad || res[1]) {
      topGetData('init')
    }
  })
})
defineExpose({
  topReload,
  columnCustom,
})
// onDeactivated(() => {
//   // 解决由于数据量大时并且滚动之后导致表格数据都被vue 监听在缓存时占用空间大
//   // topData.value = JSON.parse(JSON.stringify(topData.value))
//   // topRef.value?.clearOb?.(topData.value)
// })
onDeactivated(() => {
  topRef.value?.scrollTo(0, 0)
})
</script>
<style lang="scss">
@import '../style/query-top-search-table.scss';
</style>
